// i18n area 'backups' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.da-DK.meta.json.
import type { enUS } from './backups'

export const daDK: typeof enUS = {
  ckpt: {
    contents: 'Tager imod',
    contentsHint:
      'Hvad der må lande her. »Checkpoints« er klyngens konfiguration, »Datasikkerhedskopier« er de virtuelle maskiners: de to læsninger kombineres, én destination kan tage imod begge.',
    content: { checkpoints: 'Checkpoints', backups: 'Datasikkerhedskopier' },
    destinationsTitle: 'Backup-destinationer',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Gendannelse',
    addDestination: 'Tilføj destination',
    addDestinationTitle: 'Tilføj backup-destination',
    editDestinationTitle: 'Rediger destination',
    storage: 'Storage',
    storageHint:
      'En dir-lignende storage (dir/NFS/CIFS/CephFS) — artefakterne er normale filer under platformens namespace.',
    schedule: 'Tidsplan',
    scheduleNone: 'Kun manuel',
    scheduleHourly: 'Hver time',
    scheduleDaily: 'Daglig',
    scheduleWeekly: 'Ugentlig',
    scheduleHour: 'Klokkeslæt',
    scheduleWeekday: 'Dag',
    scheduleHint:
      'Planlagte checkpoints har ingen operatør, der taster masterpassen: keystorets hemmeligheder pakkes som placeholders.',
    retention: 'Retention',
    retentionHint:
      'Hvor mange planlagte checkpoints der beholdes — sweeperen fjerner de ældste ud over antallet. Manuelle og præ-gendannelses-checkpoints fjernes aldrig.',
    paused: 'Sat på pause',
    pausedHint:
      'Operatørens blackout: så længe pausen varer, planlægges og beskæres intet på denne destination — datapolicies såvel som checkpoints. Kørsler i gang røres aldrig.',
    orphanRuns: '{n} forældreløse kørsler',
    orphanRunsHint:
      'Planlagte kørsler fra policies, der ikke længere findes på denne destination: ingen retention styrer dem — aldrig talt, aldrig ryddet op — og kun en hånd sletter dem. Linsen »backups« i tvirt diagnose navngiver de fjernede policies.',
    rescan: 'Genadoptér artefakter',
    rescanTitle: 'Genadoption af artefakter for {name}',
    rescanHint:
      'Genopbygger backupkataloget (VM/CT/App) ud fra manifesterne for artefakterne på destinationen. Eksisterende rækker røres aldrig; backups af ukendte politikker forbliver forældreløse (beskæres aldrig automatisk). Skridtet efter en bootstrap-gendannelse.',
    masterpassDrWarning:
      'Katastrofescenarie: LUKS-diske vender KUN tilbage fra et checkpoint MED masterpass. Planlagte checkpoints pakker pladsholdere — tag jævnligt et manuelt checkpoint med masterpass.',
    policy: {
      title: 'Policies for datasikkerhedskopier',
      hint: 'Navngivne policies: hvilke objekter (kind, tags, scopes), hvor ofte, hvornår en kørsel må starte, og hvor mange kopier der beholdes. Indrulleringens gestus bliver hos objektets ejer: tags tildeles på dets eget scope.',
      add: 'Tilføj policy',
      column: 'Datapolicies',
      name: 'Navn',
      nameHint:
        'Policyens etiket, unik inden for destinationen. Kørslerne følger policyens stabile id: omdøbning er gratis; sletning gør dens kørsler forældreløse (hverken talt eller ryddet op).',
      kindLocked: 'Objektfamilien for en eksisterende policy kan ikke ændres: opret en ny policy.',
      kindLabel: 'Objekter',
      kind: { vm: 'Virtuelle maskiner', ct: 'Containere', app: 'Apps' },
      tags: 'Tag-vælger',
      tagsHint: 'Par af tag=værdi, kommaseparerede, i AND. Tomme tags og scopes vælger intet — aldrig »alt«.',
      scopes: 'Scopes',
      scopesHint: 'Scope-stier (undertræer), kommaseparerede, i OR med hinanden.',
      windowStart: 'Vindue fra',
      windowEnd: 'Vindue til',
      windowHint:
        'Udførelsesvindue (HH:MM, lokal tid; en start efter slutningen går hen over midnat). Det styrer kun STARTEN: en kørsel, der løber over, dræbes aldrig.',
      mode: 'Tilstand',
      modeHint: 'Inkrementel rider på seriefamilien; en brudt serie degraderer til en full, fortalt i journalen.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementel',
      requireQuiesce: 'Kræv quiesce (guest agent)',
      paused: 'Policy på pause',
      retentionNone: 'Behold alt',
      retentionCount: 'Antal',
      retentionGfs: 'GFS-ringe',
      gfs: { keepLast: 'Seneste', daily: 'Daglige', weekly: 'Ugentlige', monthly: 'Månedlige', yearly: 'Årlige' },
      gfsHint:
        'For hver ring beholdes den nyeste sikkerhedskopi fra hver af de sidste N perioder. En beholdt sikkerhedskopi holder hele sin kæde i live — aldrig en basis med forældreløse.',
      lastRun: 'Seneste kørsel',
      neverRan: 'aldrig kørt'
    },
    lastCheckpoint: 'Seneste checkpoint',
    neverRun: 'Aldrig taget',
    createNow: 'Opret checkpoint',
    createNowTitle: 'Opret checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Beskytter keystorets hemmelige værdier (argon2id → AES-256-GCM, pr. værdi). Den gemmes aldrig: pas på den — uden den producerer en gendannelse placeholders i stedet for de rigtige hemmeligheder.',
    masterpassEmptyHint: 'Lad stå tomt for at pakke eksplicitte placeholders i stedet for hemmelighederne.',
    createStarted: 'Checkpoint i gang…',
    destinationInUseError: "'{name}' indeholder stadig checkpoints — slet dem først.",
    origin: 'Oprindelse',
    originManual: 'manuel',
    originSchedule: 'planlagt',
    originPreRestore: 'præ-gendannelse',
    originPreChange: 'før ændring',
    preChangeRetention: 'Checkpoints før ændring',
    preChangeRetentionHint:
      'Tom = deaktiveret. Den første konfigurationsskrivning efter en stille periode fastfryser her den forrige tilstand (oprindelse „før ændring“); de nyeste beholdes op til antallet — egen, beskærbar retention.',
    diffTitle: 'Forhåndsvisning af ændringer',
    diffFailed: 'Forhåndsvisning mislykkedes',
    diffRetry: 'Prøv igen',
    diffCounts: '{changed} ændres · {missing} oprettes · {extra} overskydende · {equal} identiske',
    diffChanged: 'ændres',
    diffMissing: 'ville blive oprettet',
    diffExtra: 'ville blive slettet',
    diffJsonb: 'jsonb-referencer kan ikke verificeres før anvendelsen',
    diffSecret: 'forseglede felter, ikke sammenlignelige',
    diffMore: '{n} mere…',
    diffNeeded: 'Start aktiveres, når forhåndsvisningen afspejler valget.',
    phase: 'Status',
    phaseRunning: 'i gang',
    phaseComplete: 'komplet',
    phaseError: 'fejl',
    secrets: 'Hemmeligheder',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholders',
    size: 'Størrelse',
    created: 'Oprettet',
    destination: 'Destination',
    download: 'Download .tvbk',
    deleteCheckpoint: 'Slet checkpoint',
    noCheckpoints: 'Ingen checkpoints — opret et fra en destination.',
    families: 'Familier',
    generation: 'Generation',
    completedAt: 'Fuldført den',
    errorDetail: 'Fejldetaljer',
    manifest: 'Manifest',
    restoreHint:
      'Upload et .tvbk-artefakt: exploreren viser, hvad det indeholder, og så vælger du, hvad der skal gendannes, og hvordan.',
    uploadFile: 'Upload en .tvbk-fil',
    uploading: 'Uploader…',
    uploadFailed: 'Kunne ikke åbne artefaktet',
    explorerTitle: 'Checkpointets indhold',
    checkpointFrom: 'Checkpoint af clusteret {cluster}, oprettet den {when} ({origin}, generation {generation})',
    otherCluster:
      'Dette checkpoint stammer fra et ANDET cluster ({cluster}) — cross-cluster-gendannelse kommer i et fremtidigt round.',
    encrypted: 'krypteret',
    objectsCount: '{n} objekter',
    mode: 'Tilstand',
    modeMerge: 'Merge — afstemmer: upsert af de valgte, sletter intet',
    modeOverwrite:
      'Overwrite — checkpointet vinder: en fuldt valgt familie erstattes helt (de nuværende rækker, der ikke er i checkpointet, dør)',
    restoreMasterpassHint:
      'Masterpassen, checkpointet blev oprettet med. Uden den gendannes de krypterede hemmeligheder som eksplicitte placeholders.',
    checkMasterpass: 'Verificer',
    masterpassOk: 'Masterpassen er korrekt',
    masterpassWrong: 'Forkert masterpass',
    parachuteDestination: 'Faldskærmsdestination',
    parachuteHint: 'Før nogen række røres, opretter tasken her et automatisk præ-gendannelses-checkpoint.',
    summaryTitle: 'Hvad der vil ske',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'hele familien',
    summaryObjects: '{n} valgte objekter',
    confirmHint:
      'Skriv clusterets navn ({name}) for at bekræfte — en gendannelse omskriver den erklærede konfiguration.',
    confirmField: 'Clusterets navn',
    startRestore: 'Gendan',
    restoreRunning: 'Gendannelse i gang…',
    restoreDone: 'Gendannelse fuldført — reconcilerne konvergerer mod den nye erklæring.',
    restoreFailed: 'Gendannelsen fejlede',
    discard: 'Kassér',
    selectionEmpty: 'Vælg mindst én familie eller ét objekt.'
  },

  backup: {
    intro: {
      title: 'Backup af VM- og containerdata',
      subtitle: 'Byggeklodserne, som ekstern backupsoftware bruger',
      whatItIs:
        'TVirt udstiller fire primitiver: quiesced snapshots, change tracking per disk, read-only NBD-eksport og eksport af konfigurationen. Veeam, Bacula, Acronis og lignende styrer dem.',
      whatItIsNot:
        'TVirt er ikke et backupprodukt: det planlægger intet, håndhæver ingen retention og opbevarer intet arkiv af dine data. Retention, kataloger og gendannelsespolitikker hører til den software, du allerede bruger.'
    },
    cbt: {
      title: 'Ændringssporing',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Tilstand',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Observeret',
      colChangeId: 'Change-ID',
      colMechanic: 'Mekanisme',
      stateActive: 'Aktiv',
      stateInactive: 'Fra',
      stateInconsistent: 'Inkonsistent — næste backup skal være fuld',
      stateBroken: 'Kæde brudt — deaktivér, og aktivér derefter som ny kæde',
      stateSnapshots: 'Altid til — delta mellem snapshots',
      stateUnavailable: 'Ikke tilgængelig på denne disk',
      mechanic: {
        'qcow2-bitmap': 'qcow2-bitmap',
        'rbd-snapdiff': 'Ceph-snapshotdiff',
        'lvm-thin-delta': 'Thin pool-delta',
        none: 'Ingen'
      },
      empty:
        'Ingen VM-disk. Ændringssporing læses pr. disk: aktivér den på en qcow2-disk, eller tag snapshots på rbd/SAN.',
      chainBroken: 'Kæde brudt',
      chainBrokenText:
        'Brudt af en {reason}: {bitmaps}. Deaktivér bitmappen (kæden er tabt, næste backup er fuld), og aktivér den som ny kæde.',
      lineages: 'Epoker',
      epochFrozen: 'frosset i snapshot {snapshot}',
      epochLost: 'tabt ({cause})',
      epochRecording: 'optager på hovedet',
      milestones: 'Snapshot-milepæle',
      enable: 'Aktivér ændringssporing',
      disable: 'Deaktivér',
      reset: 'Nulstil',
      changedAreas: 'Ændrede områder',
      denied: 'Du mangler rettigheden på denne VM',
      enableTitle: 'Aktivér ændringssporing',
      disableTitle: 'Deaktivér ændringssporing',
      resetTitle: 'Nulstil bitmappen',
      areasTitle: 'Ændrede områder',
      bitmapName: 'Bitmapnavn',
      bitmapNameHint: 'Dit eget navn: tvirt- og tvbk- tilhører platformen',
      granularity: 'Granularitet (bytes)',
      granularityHint: 'En potens af to; 65536 som standard',
      bitmap: 'Bitmap',
      disableHint: 'Fjerner bitmappen og hele dens epokehistorik: næste backup skal være fuld.',
      resetHint: 'Tømmer bitmappen — en ny basis: et change-ID fra før nulstillingen kan ikke længere sammensættes.',
      areasFrom: 'Fra snapshot',
      areasTo: 'Til snapshot',
      areasRun: 'Beregn',
      areasResult: '{count} ændrede områder, {bytes}',
      areasEmpty: 'Intet ændret område mellem de to snapshots',
      areasZero: 'nuller',
      areasMore: 'de første {shown} af {count} vist',
      submit: 'Bekræft',
      error: 'Handlingen for ændringssporing mislykkedes'
    },
    exports: {
      title: 'Åbne NBD-eksporter',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Fase',
      colNode: 'Node',
      colEndpoint: 'Endpoint',
      colExpires: 'Udløber',
      colCreated: 'Åbnet',
      colError: 'Fejl',
      phase: {
        preparing: 'Forbereder',
        ready: 'Klar',
        closed: 'Lukket',
        error: 'Mislykkedes'
      },
      expiresIn: 'om {minutes} min',
      expired: 'udløbet',
      empty: 'Ingen eksport. En læsesession serverer én disk ved ét snapshot til en NBD-klient; en skrivesession fylder en urørt disk på en stoppet VM. Begge dør ved udløb.',
      endpointHint: 'TLS med klyngens CA; eksportnavnet er billetten — den dør med sessionen',
      closeDenied: 'Du mangler rettigheden til at lukke eksporter på denne VM',
      open: 'Åbn NBD-eksport',
      openTitle: 'Åbn en NBD-eksport',
      openDisk: 'Disk',
      openBitmap: 'Bitmap (valgfri)',
      openBitmapHint:
        'Udgiver den bitmaps epoke frosset i dette snapshot som meta-context for de ændrede extents (kun qcow2-diske)',
      openTtl: 'Levetid (minutter)',
      openSubmit: 'Åbn',
      openError: 'Eksporten kunne ikke åbnes',
      colMode: 'Tilstand',
      mode: {
        read: 'Læsning',
        write: 'Skrivning'
      },
      caCertificate: 'Klyngens CA',
      caCopy: 'Kopiér PEM',
      caDownload: 'Hent ca-cert.pem',
      caHint: 'Skriv PEM\'en til ca-cert.pem i en privat mappe og forbind med nbds://…?tls-certificates=<mappe> (nbdcopy, nbdinfo) eller --object tls-creds-x509,dir=<mappe>,endpoint=client (qemu-img)',
      caAbsent: 'Sessionen bærer ingen CA (ingen PKI)',
      openWrite: 'Åbn skrive-eksport',
      openWriteTitle: 'Åbn en skrive-eksport',
      openWriteIntro: 'Disken skal være urørt: født tom, aldrig skrevet, uden snapshot; VM\'en stoppet. Gendannelsen FYLDER disken, den reparerer den ikke. Mens sessionen er åben, kan VM\'en ikke starte, tage snapshot eller klones, og disken kan ikke flyttes.',
      openWriteSubmit: 'Åbn',
      openWriteError: 'Skrive-eksporten kunne ikke åbnes',
      openWriteDenied: 'Du mangler vm.restore.data på denne VM',
      openWriteStopped: 'Stop VM\'en for at åbne en skrive-eksport',
      fromDescription: 'Opret VM fra beskrivelse',
      fromDescriptionTitle: 'Opret en VM fra en beskrivelse',
      fromDescriptionIntro: 'Beskrivelsen fra export-vm-meta kommer tilbage som en stoppet VM med tomme diske i den beskrevne geometri — klar til skrive-eksporterne, disk for disk. Bytes passerer ikke her: restore-disk (CLI) eller backupproduktets NBD-klient bærer dem.',
      fromDescriptionDoc: 'Beskrivelse (JSON)',
      fromDescriptionDocHint: 'Indsæt dokumentet fra export-vm-meta, eller vælg filen',
      fromDescriptionFile: 'Vælg fil…',
      fromDescriptionInvalid: 'Teksten er ikke et JSON-dokument',
      fromDescriptionName: 'Navn på den nye VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Dit hjemme-scope',
      fromDescriptionStorage: 'Disk-storage',
      fromDescriptionStorageHint: 'Hver disk fødes her, i storagens standardformat',
      fromDescriptionMetadataStorage: 'Metadata-storage',
      fromDescriptionSameAsStorage: 'Samme som diskene',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Uden bridge eller netværk fødes VM\'en uden netkort',
      fromDescriptionNetwork: 'Logisk netværk (fabric/netværk)',
      fromDescriptionSubmit: 'Opret',
      fromDescriptionError: 'VM\'en kunne ikke oprettes',
      fromDescriptionDone: 'VM oprettet: {name}',
      fromDescriptionOpen: 'Åbn VM\'en',
      fromDescriptionDenied: 'Du mangler vm.create',
      fromDescriptionStillRunning: 'Oprettelsen kører stadig: der ventes videre'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: "Datasikkerhedskopier af VM'er",
      titleOnVm: 'Datasikkerhedskopier',
      empty:
        'Ingen sikkerhedskopi. En sikkerhedskopi fører diskene, UEFI-varstore og vTPM-tilstanden over til en destination og overlever den virtuelle maskine.',
      colVm: 'VM',
      colCreated: 'Taget',
      colPhase: 'Udfald',
      colDestination: 'Destination',
      colContains: 'Indhold',
      colSize: 'Størrelse',
      colOrigin: 'Oprindelse',
      colMode: 'Type',
      retentionChip: 'Opbevaring',
      retentionHint:
        'Destinationens opbevaring kan slette denne sikkerhedskopi uden at spørge: den er født af en planlægning. Manuelle sikkerhedskopier fejes aldrig.',
      policyRemoved: 'Policy fjernet: {name}',
      policyRemovedHint:
        'Den policy, der planlagde denne backup, findes ikke længere: ingen retention styrer den (ryddes aldrig op automatisk) — slet den manuelt, når den ikke længere er nødvendig.',
      phase: {
        running: 'I gang',
        complete: 'Fuldført',
        error: 'Mislykkedes'
      },
      origin: {
        manual: 'Manuel',
        schedule: 'Planlagt'
      },
      mode: {
        full: 'Fuld',
        incremental: 'Inkrementel'
      },
      contains: {
        disks: 'Diske',
        varstore: 'UEFI-varstore',
        vtpm: 'vTPM-tilstand',
        snapshots: 'Snapshots'
      },
      vmState: {
        stopped: 'VM slukket',
        running: 'VM kørende (varm)'
      },
      artifactClass: { metadata: 'Metadata', data: 'Data', secret: 'Hemmelighed' },
      detail: {
        tabOverview: 'Overblik',
        tabArtefact: 'Artefakt',
        id: 'Identifikator',
        scope: 'Omfang',
        vmState: 'VM-tilstand ved kopieringen',
        pointInTime: 'Dataenes tidspunkt',
        completedAt: 'Afsluttet',
        node: 'Node der kopierede',
        error: 'Fejl',
        path: 'Mappe på lageret',
        checksum: 'sha256 for manifestet',
        secretsExposed: 'Følsomt materiale i klartekst',
        secretsExposedYes: 'Ja — destinationen krypterer ikke',
        secretsExposedNo: 'Nej',
        baseBackup: 'Basissikkerhedskopi',
        tabManifest: 'Manifest',
        manifestHint:
          'Artefaktets indeks i klartekst: én fil per række med sin sha256. Mappen kan verificeres uden TVirt — qemu-img, tar og jq er nok.',
        manifestEmpty: 'Manifestet nævner ingen filer.',
        manifestError: 'Manifestet kan ikke læses',
        colEntry: 'Fil',
        colClass: 'Klasse',
        colSha: 'sha256'
      },
      create: {
        action: 'Tag sikkerhedskopi nu',
        title: 'Tag sikkerhedskopi nu',
        submit: 'Start sikkerhedskopieringen',
        destination: 'Destination',
        destinationHint: 'Kun destinationer, der tager imod sikkerhedskopier.',
        noDestinations: 'Ingen destination tager imod sikkerhedskopier: opret en under System → Checkpoints.',
        contentsHint:
          'Alle diske rejser med, plus UEFI-varstore og vTPM-tilstanden. De to sidste er selve pointen: en forseglet gæst skal kunne starte igen.',
        error: 'Sikkerhedskopieringen startede ikke',
        stillRunning: 'Sikkerhedskopieringen er stadig i gang — kopien fortsætter, også hvis du lukker.',
        vmRunning:
          'Den virtuelle maskine er {phase}: en backup kræver en afklaret VM — slukket for den kolde kopi, kørende for den varme.'
      },
      restore: {
        action: 'Gendan',
        title: 'Gendan',
        intro:
          'Gendannelse er uigenkaldelig. Vælg, hvor data skal tilbage: til en ny maskine eller oven på den oprindelige.',
        modeNewVm: 'Gendan til en NY VM',
        modeNewVmHint:
          'Rører intet af det, der findes — det er valget, man verificerer en sikkerhedskopi med. Ny identifikator og friske MAC-adresser.',
        modeOver: 'Overskriv den oprindelige VM',
        modeOverHint: "Ødelægger mål-VM'ens nuværende data, uden vej tilbage. Den virtuelle maskine skal være slukket.",
        newName: 'Navn på den nye VM',
        newNameHint: 'Det skal være ledigt i målomfanget.',
        storage: 'Lager til diskene',
        storageHint: 'Obligatorisk: manifestet noterer en disks størrelse og format, aldrig det lager, den lå på.',
        metadataStorage: 'Lager til varstore og vTPM',
        metadataStorageHint: 'Hvor UEFI-identiteten og vTPM-tilstanden lander.',
        sameAsStorage: 'Samme som diskene',
        bridge: 'Værtens bridge',
        bridgeHint:
          "Hvert registreret netværkskort kommer tilbage på denne bridge med en ny MAC. Efterladt tomt fødes VM'en uden kort — det sikrere standardvalg.",
        overwriteTitle: 'Du er ved at overskrive denne VM',
        overwriteName: 'Navn',
        overwriteId: 'Identifikator',
        overwriteDisks: 'Diske der bliver overskrevet',
        overwriteNoDisks: 'Ingen diske.',
        overwriteKeeps:
          'Urørt forbliver identifikator, navn, omfang, netværkskort og MAC-adresser: en sikkerhedskopi er DATAENE, konfigurationen er checkpointet.',
        confirmField: "VM'ens navn",
        confirmHint: 'Skriv {name} for at bekræfte.',
        targetLoading: "Læser mål-VM'en…",
        targetRunning:
          "Mål-VM'en er {phase}: en gendannelse omskriver byte under gæsten og kræver derfor, at den er slukket.",
        targetGone: 'Den oprindelige VM kan ikke længere læses: gendannelse til en ny VM står tilbage.',
        onlyComplete: 'Sikkerhedskopien er {phase}: kun en fuldført sikkerhedskopi kan gendanne.',
        submitNewVm: 'Gendan til den nye VM',
        submitOver: 'Overskriv',
        error: 'Gendannelsen startede ikke',
        stillRunning: 'Gendannelsen er stadig i gang — at kopiere hele diske tager tid.'
      }
    },
    guest: {
      title: {
        ct: 'Databackupper af containere',
        app: 'Databackupper af Apps'
      },
      tabTitle: 'Backupper',
      empty: 'Ingen backupper. En backup kopierer de persistente data til en destination og overlever sit objekt.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Taget',
      colPhase: 'Udfald',
      colDestination: 'Destination',
      colContains: 'Indhold',
      colSize: 'Størrelse',
      colOrigin: 'Oprindelse',
      policyRemoved: 'Policy fjernet: {name}',
      policyRemovedHint:
        'Den policy, der planlagde denne backup, findes ikke længere: ingen retention styrer den (ryddes aldrig op automatisk) — slet den manuelt, når den ikke længere er nødvendig.',
      phase: {
        running: 'I gang',
        complete: 'Fuldført',
        error: 'Mislykket'
      },
      origin: {
        manual: 'Manuel',
        schedule: 'Planlagt'
      },
      state: {
        stopped: 'Objekt stoppet',
        running: 'Objekt kørende (frosset)'
      },
      contains: {
        rootfs: 'Rootfs-træ',
        config: 'Konfiguration',
        volumes: 'Persistente volumener',
        root: 'Persistent root'
      },
      artifactClass: {
        metadata: 'Metadata',
        data: 'Data',
        secret: 'Hemmelig'
      },
      create: {
        action: 'Tag backup nu',
        title: 'Ny backup',
        submit: 'Start backuppen',
        error: 'Backuppen startede ikke',
        destination: 'Destination',
        destinationHint: 'Kun destinationer der accepterer databackupper.',
        noDestinations: 'Ingen destination accepterer databackupper: tilføj “Databackupper” til en destination.',
        hint: {
          ct: "Hele rootfs-træet rejser med, trofast (numeriske ejere, xattrs, ACL'er), plus den deklarerede konfiguration i manifestet. En kørende container FRYSES under hele pakningen: crash-konsistent kopi, deklareret.",
          app: 'KUN de persistente volumener (og den persistente root) rejser med, plus konfigurationen i manifestet. Det efemere er udelukket ved ratifikation, og manifestet nævner det; env-værdier deklareret hemmelige rejser ikke.'
        },
        stillRunning: 'Backup stadig i gang — at pakke hele træer tager tid.'
      },
      detail: {
        tabOverview: 'Oversigt',
        tabManifest: 'Manifest',
        id: 'Identifikator',
        scope: 'Omfang',
        state: 'Tilstand ved kopien',
        pointInTime: 'Data pr. øjeblik',
        completedAt: 'Afsluttet',
        node: 'Node der kopierede',
        error: 'Fejl',
        path: 'Mappe på lageret',
        checksum: 'manifest-sha256',
        manifestHint:
          'Artefaktets indeks: én post pr. fil med dens sha256 — uden hasherne er “backuppen er der” en troshandling.',
        manifestError: 'Manifestet kan ikke læses',
        manifestEmpty: 'Ingen artefakter i manifestet.',
        colEntry: 'Fil',
        colClass: 'Klasse',
        colSha: 'sha256',
        excluded: 'Udelukket ved ratifikation (rejser ikke)',
        secretKeys: 'Udeladte hemmelige env-nøgler (#307) — indtast dem igen efter en gendannelse'
      },
      restore: {
        action: 'Gendan',
        title: 'Gendannelse',
        submit: 'Gendan',
        error: 'Gendannelsen startede ikke',
        stillRunning: 'Gendannelse stadig i gang — at udpakke hele træer tager tid.',
        onlyComplete: 'Backuppen er {phase}: kun en fuldført backup kan gendanne.',
        asNew: {
          ct: 'I en NY container — ødelægger intet: gestussen man kontrollerer en backup med',
          app: 'I en NY App — ødelægger intet: gestussen man kontrollerer en backup med'
        },
        over: {
          ct: 'OVER kildecontaineren — hele rootfs-træet erstattes',
          app: 'OVER kilde-Appen — indholdet af hvert persistent volumen erstattes'
        },
        name: 'Navn på det nye objekt',
        storage: 'Lager',
        storageHint: 'Hvor de gendannede data lander — manifestet registrerer aldrig den mistede pool.',
        storageDeclared: 'Lagrene deklareret i manifestet',
        bridge: 'Host-bridge',
        bridgeHint:
          'Hvert registreret netkort kommer tilbage på denne bridge med en frisk MAC. Tom = født uden tilslutning, den sikreste standard.',
        node: 'Node',
        nodeHint: 'Medlemmet Appen genfødes på: noden er klyngeidentitet og kommer aldrig fra manifestet.',
        secretKeysWarning:
          'Env-værdier deklareret hemmelige rejser ikke i backuppen: den genfødte kopi vil have dem indtastet igen (task-loggen nævner nøglerne).',
        overInventory: 'Du er ved at overskrive dette objekt',
        confirmType: 'Skriv {name} for at bekræfte',
        targetGone: 'Kildeobjektet kan ikke længere læses: gendannelse som nyt er stadig muligt.',
        targetLoading: 'Læser målobjektet…',
        targetRunning: 'Målobjektet kører: en gendannelse erstatter bytes under gæsten og vil have det stoppet.'
      }
    }
  }
}
